import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { winnersExportQueryKey } from 'hooks/api/Exports/useGetExportForWinnersByContestId'
import { type SweepstakeWinnerStatusType } from 'src/types/api'
import { invalidateQueryKeys } from './invalidateQueryKeys'

interface SweepstakeWinnersMessageData {
  sweepstakeWinnerIds: number[]
  status: SweepstakeWinnerStatusType
}

interface UsePutSweepstakeWinnerBulkUpdateStatusProps {
  onSuccess?: () => void
  onError?: () => void
  invalidateQueryKeys?: readonly QueryKey[]
}

export const usePutSweepstakeWinnerBulkUpdateStatus = ({
  onSuccess,
  onError,
  invalidateQueryKeys: queryKeysToInvalidate,
}: UsePutSweepstakeWinnerBulkUpdateStatusProps) => {
  const queryClient = useQueryClient()

  const putSweepstakeWinnerBulkUpdateStatus = useTypedApiClient({
    path: '/admin/sweepstake-winners/bulkUpdateStatus',
    method: 'put',
  })

  return useMutation({
    mutationFn: async (request: SweepstakeWinnersMessageData) => {
      const { data } = await putSweepstakeWinnerBulkUpdateStatus(request)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: winnersExportQueryKey })
      if (
        queryKeysToInvalidate !== undefined &&
        queryKeysToInvalidate.length > 0
      ) {
        await invalidateQueryKeys(queryClient, queryKeysToInvalidate)
      } else {
        await queryClient.invalidateQueries({
          queryKey: ['/sweepstakes'],
        })
      }

      onSuccess?.()
    },
    onError,
  })
}
